import ShopPicker from './ShopPicker.vue';
import ShopPickerDialog from './ShopPickerDialog.vue';

export {
  ShopPicker,
  ShopPickerDialog
};

export default ShopPicker;
